<template>
  <div
    class="reload-report"
    :class="{
      'reload-report--loading': loading,
    }"
    @click="onClick"
  >
    <gl-icon
      gray
      :height="24"
      name="reload-2"
      :width="24"
    />
    <span class="reload-report__text"> {{ reloadText }}</span>
  </div>
</template>

<script>
import GlIcon from '@/components/gl-icon'

export default {
  components: {
    GlIcon,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    reloadInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    subscription() {
      return this.reloadInfo.subscription
    },
    reloadText() {
      const {
        canUpdate,
        freeUpdatesLimit,
        freeUpdatesUsed,
        isFreeUpdate,
        quotaCost,
      } = this.subscription || {}

      if (canUpdate) {
        if (isFreeUpdate && freeUpdatesLimit && freeUpdatesLimit > 0) {
          return `Update Data (${freeUpdatesLimit - freeUpdatesUsed} Free)`
        }

        if (quotaCost) {
          return `Update Data (− ${quotaCost} Report)`
        }
      }

      return 'Update Data'
    },
  },
  methods: {
    onClick() {
      if (this.loading) return
      this.$emit('on-reload')
    },
  },
}
</script>

<style scoped>
.reload-report {
  display: flex;
  height: 40px;
  padding: 0px 12px 0px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: var(--Basic-100, rgba(9, 21, 64, 0.04));
  color: var(--Basic-900, #091540);
  text-align: center;
  font-size: var(--Size-M, 14px);
  font-weight: 600;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
  cursor: pointer;
  user-select: none;
}
.reload-report--loading {
  opacity: 0.68;
  cursor: wait;
}
.reload-report--loading .gl-icon {
  animation: 3000ms spin infinite linear;
}
</style>
